<template>
  <Command @click="trigger">
    <slot
      v-bind="{
        disabled: false,
        icon: 'location_searching',
        label: $t('moreOptions.goToPosition'),
        toolTip: $t('moreOptions.goToPosition'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { OverlayType, useUILayers } from "@/components/UILayers";
import GoToPosition from "@/components/reader/GoToPosition.vue";

import { posthogKeys } from "@/helpers/constants";
import { usePostHog } from "@/helpers/posthog";

import Command from "../command";

const layers = useUILayers();

const { capture: capturePosthogEvent } = usePostHog();

function trigger() {
  capturePosthogEvent(posthogKeys.goToPosition);
  layers.add(GoToPosition, {}, { overlay: OverlayType.Transparent });
}
</script>
